/** Ids: readable slugs for catalog records, opaque ids for basket entries and lines. */

/** "Peanut Noodles (Skurka)" → "peanut-noodles-skurka". Never empty. */
export function slugify(text: string): string {
  const slug = text
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
  return slug || 'item'
}

/** `base` (slugified) if free, else base-2, base-3, ... */
export function uniqueId(existing: Iterable<string>, base: string): string {
  const taken = existing instanceof Set ? (existing as Set<string>) : new Set(existing)
  const slug = slugify(base)
  if (!taken.has(slug)) return slug
  for (let n = 2; ; n++) {
    const candidate = `${slug}-${n}`
    if (!taken.has(candidate)) return candidate
  }
}

/**
 * A fresh opaque id, "b-1a2b3c4d...". Randomness lives here and only here; the engine's
 * calculations never call it.
 */
export function newId(prefix: string): string {
  const c = (globalThis as { crypto?: { randomUUID?: () => string } }).crypto
  const raw =
    typeof c?.randomUUID === 'function'
      ? c.randomUUID().replace(/-/g, '')
      : Array.from({ length: 32 }, () => Math.floor(Math.random() * 16).toString(16)).join('')
  return `${prefix}-${raw.slice(0, 16)}`
}
